import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as n, renderSlot as V, createElementVNode as l, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, k = { key: 1 }, M = { key: 2 }, Z = { key: 3 }, h = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconLineVertical"
}, H = /* @__PURE__ */ p({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = m(s);
    return (i, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(d)), [
      V(i.$slots, "default"),
      n(a) === "bold" ? (o(), e("g", f, t[0] || (t[0] = [
        l("path", { d: "M140,24V232a12,12,0,0,1-24,0V24a12,12,0,0,1,24,0Z" }, null, -1)
      ]))) : n(a) === "duotone" ? (o(), e("g", k, t[1] || (t[1] = [
        l("path", {
          d: "M224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M136,24V232a8,8,0,0,1-16,0V24a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : n(a) === "fill" ? (o(), e("g", M, t[2] || (t[2] = [
        l("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM136,192a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : n(a) === "light" ? (o(), e("g", Z, t[3] || (t[3] = [
        l("path", { d: "M134,24V232a6,6,0,0,1-12,0V24a6,6,0,0,1,12,0Z" }, null, -1)
      ]))) : n(a) === "regular" ? (o(), e("g", h, t[4] || (t[4] = [
        l("path", { d: "M136,24V232a8,8,0,0,1-16,0V24a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : n(a) === "thin" ? (o(), e("g", w, t[5] || (t[5] = [
        l("path", { d: "M132,24V232a4,4,0,0,1-8,0V24a4,4,0,0,1,8,0Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  H as default
};
